import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IAccreditation } from './accreditation';
import { IAccreditationFormValues } from './accreditationFormValues';
import { IAccreditationUpsert } from './accreditationUpsert';
import moment from 'moment';
import { IFarm } from '../farm/farm';
import { z } from "zod";
import { IOptionType } from '@zz2/zz2-ui';

export default class AccreditationModelHelper {
    public static createFormValues = (accreditation : IAccreditation | null, farms : Array<IFarm>) : IAccreditationFormValues => {
        if (!accreditation) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            issueDate: moment.utc().local(),
            expirationDate: moment.utc().local().add(3, 'years'),
            farms: [],
            isActive: true,
        };

        const farmOptions = farms
            .filter(x => x.isActive && accreditation.farmIds.includes(x.id))
            .map(x => { // TODO: OptionType.FromDataModel
                return {
                    value: x.id,
                    label: x.name,
                }
            });

        return {
            id: accreditation.id,
            guid: accreditation.guid,
            code: accreditation.code,
            name: accreditation.name,
            issueDate: moment.utc(accreditation.issueDate).local(),
            expirationDate: moment.utc(accreditation.expirationDate).local(),
            farms: farmOptions,
            isActive: accreditation.isActive,
        };
    };

    public static createUpsert = (formValues : IAccreditationFormValues) : IAccreditationUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            issueDate: formValues.issueDate,
            expirationDate: formValues.expirationDate,
            farmIds: formValues.farms.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IAccreditationFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        issueDate: Yup.mixed<moment.Moment>().defined().required('Required'),
        expirationDate: Yup.mixed<moment.Moment>().defined().required('Required'),
        farms: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
